import ClientCasePage from "@/pages/ClientCasePage";

export default {
    path: '/cases/:id',
    name: 'cases.show',
    component: ClientCasePage
}